function nav () {
    const subnavLink = document.querySelectorAll('.subnav-link')
    const subNav = document.querySelectorAll('.subnav')
    const subNavWrapper = document.querySelectorAll('.subnav-wrapper')
    const navOverflow = document.querySelector('.subnav-overflow')
    
    if(window.innerWidth >= 1241) {
        subNavWrapper.forEach(el=> {
            el.addEventListener('mouseenter', function() {
                navOverflow.classList.add('show')

                this.classList.add('active')
                const targetSubNav = this.querySelector('.subnav')

                targetSubNav.classList.add('show')
            })

            el.addEventListener('mouseleave', ()=> {
                subNav.forEach(el=> el.classList.remove('show'))
                subNavWrapper.forEach(el=> el.classList.remove('active'))

                navOverflow.classList.remove('show')
            })
        })
    }

    if(window.innerWidth <= 1240) {
        subnavLink.forEach(el=> {
            el.addEventListener('click', function() {
                const parent = this.closest('.subnav-wrapper')
                parent.classList.toggle('active')

                const targetSubNav = parent.querySelector('.subnav')

                if(parent.classList.contains('active')) {
                    targetSubNav.classList.add('show')
                } else {
                    targetSubNav.classList.remove('show')
                }
            })
        })
    }

    const nav = document.querySelector('.nav')
    const navClose = document.querySelector('.nav-close')

    document.addEventListener('click', (e)=> {
        if(e.target && e.target.classList.contains('nav')) {
            nav.classList.remove('show')
        }
    })

    navClose.addEventListener('click', ()=> {
        nav.classList.remove('show')
    })
}

export default nav;